import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, BookOpenIcon, AwardIcon, UsersIcon, ClockIcon, PhoneIcon, ActivityIcon, BrainIcon, SparklesIcon, HeartIcon, EyeIcon, ThermometerIcon, MailIcon, ClipboardIcon, CreditCardIcon, CalendarIcon } from 'lucide-react';
export function Education() {
  const courses = [{
    title: 'Master Tung Acupuncture Training',
    duration: '3-5 days (24-40 hours)',
    fee: '₹20,000-₹35,000',
    icon: AwardIcon,
    highlights: ["Introduction to Master Tung's unique 740-point system", 'Distal point needling techniques for rapid pain relief', 'Treatment protocols for musculoskeletal and internal disorders', 'Hands-on supervised clinical practice', 'Dao Ma technique for organ dysfunction']
  }, {
    title: 'Dr. Tan Balance Method Training',
    duration: '3-4 days (24-32 hours)',
    fee: '₹15,000-₹25,000',
    icon: ActivityIcon,
    highlights: ['Acupuncture 1, 2, 3 protocol for immediate pain relief', 'Five systems of meridian balancing', 'Distal point selection using mirroring techniques', 'Instant assessment of treatment effectiveness', 'Minimal needles with maximum effectiveness']
  }, {
    title: 'Zhu Scalp Acupuncture Certification',
    duration: '5-7 days (40-56 hours)',
    fee: '₹30,000-₹45,000',
    icon: BrainIcon,
    highlights: ['Neuroanatomy and functional brain zones', 'Complete scalp zone mapping', 'Treatment for stroke, paralysis, and neurological disorders', '95% effectiveness rate protocols', 'Supervised clinical practice with neurological patients']
  }, {
    title: 'Facial Cosmetic Acupuncture Certification',
    duration: '4-5 days (32-40 hours)',
    fee: '₹25,000-₹35,000',
    icon: SparklesIcon,
    highlights: ['Facial anatomy and aging process', 'Three principles of cosmetic acupuncture', 'Treatment protocols for wrinkles and sagging', 'Non-surgical facial rejuvenation techniques', 'Live model demonstrations']
  }, {
    title: 'Korean Cosmetic Acupuncture',
    duration: '3-4 days',
    fee: '₹28,000-₹40,000',
    icon: SparklesIcon,
    highlights: ['Jae-Seng Acupuncture for cell regeneration', 'Korean approach to facial muscle tensegrity', 'Specialized facial point insertion techniques', 'Collagen induction therapy', 'Integration with cooling therapies']
  }, {
    title: 'Fertility Acupuncture Specialist',
    duration: '4-5 days (32-40 hours)',
    fee: '₹30,000-₹42,000',
    icon: HeartIcon,
    highlights: ['Reproductive anatomy from TCM and Western perspectives', 'Treatment for PCOS, endometriosis, and ovulatory disorders', 'IVF support protocols increasing pregnancy rates', 'Male infertility and sperm quality enhancement', 'Evidence-based point prescriptions']
  }, {
    title: 'Advanced Tongue Diagnosis',
    duration: '2-3 days (16-24 hours)',
    fee: '₹12,000-₹18,000',
    icon: EyeIcon,
    highlights: ['Complete tongue anatomy and TCM theory', 'Tongue body characteristics and mapping', 'Pattern differentiation techniques', 'Photographic case studies', 'Integration with pulse diagnosis']
  }, {
    title: 'Comprehensive Pulse Diagnosis',
    duration: '2-3 days (16-24 hours)',
    fee: '₹12,000-₹18,000',
    icon: ActivityIcon,
    highlights: ['Pulse positions and organ correspondences', '28 classical pulse qualities', 'Palpation techniques and sensitivity development', 'Pattern identification through pulse', 'Clinical decision-making']
  }, {
    title: 'Diabetes Management with Acupuncture',
    duration: '4 days (32 hours)',
    fee: '₹18,000-₹25,000',
    icon: ThermometerIcon,
    highlights: ['TCM understanding of diabetes', 'Blood sugar regulation protocols', 'Diabetic neuropathy treatment', 'Insulin sensitivity enhancement', 'Comprehensive course manual with 200+ slides']
  }, {
    title: 'Pain Management Acupuncture Intensive',
    duration: '3-4 days (24-32 hours)',
    fee: '₹20,000-₹28,000',
    icon: ThermometerIcon,
    highlights: ['Comprehensive pain physiology', 'Master Tung points for immediate relief', 'Balance Method for musculoskeletal pain', 'Electroacupuncture applications', 'Chronic vs. acute pain strategies']
  }, {
    title: 'Stroke Rehabilitation & Neurological Acupuncture',
    duration: '4-5 days (32-40 hours)',
    fee: '₹28,000-₹38,000',
    icon: BrainIcon,
    highlights: ['Scalp acupuncture with 95% effectiveness', 'Motor function recovery mechanisms', 'Treatment for hemiplegia and aphasia', 'Electroacupuncture for muscle strength', 'Integration with physical rehabilitation']
  }];
  const enrollmentSteps = [{
    number: '1',
    icon: BookOpenIcon,
    title: 'Course Selection',
    description: 'Browse available courses or contact our admissions office for guidance'
  }, {
    number: '2',
    icon: ClipboardIcon,
    title: 'Prerequisites Verification',
    description: 'Ensure you meet prerequisite requirements for your chosen program'
  }, {
    number: '3',
    icon: ClipboardIcon,
    title: 'Registration',
    description: 'Complete online registration form with required documents'
  }, {
    number: '4',
    icon: CreditCardIcon,
    title: 'Fee Payment',
    description: 'Full payment required at registration for course confirmation'
  }, {
    number: '5',
    icon: MailIcon,
    title: 'Course Confirmation',
    description: 'Receive confirmation email with schedule and preparation materials'
  }, {
    number: '6',
    icon: CalendarIcon,
    title: 'Course Attendance',
    description: 'Attend all sessions with minimum 90% attendance for certification'
  }];
  const benefits = ['Early Bird Discount: 10-15% off when registering 30+ days in advance', 'Group Discount: 15-20% off for groups of 3+ participants', 'Alumni Benefits: 20% off additional courses for previous AIIMR students', 'Lifetime access to course materials with periodic updates', 'Continuing education credits and certificate of completion', 'Clinical mentorship opportunities available'];
  const studentPersonas = [{
    icon: AwardIcon,
    title: 'Licensed Practitioners',
    description: 'Licensed acupuncturists and TCM practitioners expanding into specialized techniques (Master Tung, Balance Method, Scalp, Abdominal Acupuncture)'
  }, {
    icon: UsersIcon,
    title: 'Healthcare Professionals',
    description: 'Western healthcare professionals—physiotherapists, neurologists, gynecologists—seeking integrative skills'
  }, {
    icon: GraduationCapIcon,
    title: 'Recent Graduates',
    description: 'Recent graduates in alternative therapies aiming for certification and clinical mentorship'
  }, {
    icon: BookOpenIcon,
    title: 'Educators & Researchers',
    description: 'Healthcare educators and researchers interested in evidence-based integrative medicine'
  }, {
    icon: ActivityIcon,
    title: 'Medical Students',
    description: 'Medical students and allied health professionals exploring complementary modalities'
  }];
  return <div className="w-full bg-white" data-id="element-588">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-589">
        <div className="max-w-7xl mx-auto text-center" data-id="element-590">
          <GraduationCapIcon className="w-16 h-16 text-blue-600 mx-auto mb-6" data-id="element-591" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-592">
            Educational Offerings
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-593">
            Professional Training Programs in Traditional Chinese Medicine &
            Integrative Therapies
          </p>
        </div>
      </section>
      <section className="py-16 px-4 bg-gray-50 w-full" data-id="element-594">
        <div className="max-w-7xl mx-auto" data-id="element-595">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-596">
            Student & Practitioner Personas
          </h2>
          <p className="text-gray-600 text-center max-w-3xl mx-auto mb-12" data-id="element-597">
            Our educational programs attract:
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-598">
            {studentPersonas.map((persona, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow" data-id="element-599">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4" data-id="element-600">
                  <persona.icon className="w-6 h-6 text-teal-600" data-id="element-601" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-602">
                  {persona.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-603">{persona.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-604">
        <div className="max-w-7xl mx-auto" data-id="element-605">
          <div className="text-center mb-12" data-id="element-606">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-607">
              Comprehensive Certification Courses
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-608">
              World-class training programs combining theoretical knowledge with
              extensive hands-on clinical practice, ensuring graduates are
              confident, competent practitioners
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-609">
            {courses.map((course, index) => <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-shadow" data-id="element-610">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-teal-100 rounded-lg flex items-center justify-center mb-4" data-id="element-611">
                  <course.icon className="w-6 h-6 text-blue-600" data-id="element-612" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-613">
                  {course.title}
                </h3>
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-614">
                  <ClockIcon className="w-4 h-4 mr-2" data-id="element-615" />
                  <span data-id="element-616">{course.duration}</span>
                </div>
                <div className="text-lg font-bold text-blue-600 mb-4" data-id="element-617">
                  {course.fee}
                </div>
                <ul className="space-y-2 mb-4" data-id="element-618">
                  {course.highlights.map((highlight, hIndex) => <li key={hIndex} className="flex items-start text-sm text-gray-700" data-id="element-619">
                      <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-620"></div>
                      <span data-id="element-621">{highlight}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-white w-full" data-id="element-622">
        <div className="max-w-7xl mx-auto" data-id="element-623">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-624">
            Course Fees & Payment Options
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-625">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-2xl shadow-lg" data-id="element-626">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-627">
                Flexible Payment Plans
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-628">
                We offer installment options to make our courses accessible:
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-629">
                <li className="flex items-start" data-id="element-630">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-631"></div>
                  <span data-id="element-632">Monthly installment plans available</span>
                </li>
                <li className="flex items-start" data-id="element-633">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-634"></div>
                  <span data-id="element-635">No additional interest charges</span>
                </li>
                <li className="flex items-start" data-id="element-636">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-637"></div>
                  <span data-id="element-638">Flexible payment schedules</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-2xl shadow-lg" data-id="element-639">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-640">
                Early Bird Discounts
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-641">
                Save on course fees with our special offers:
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-642">
                <li className="flex items-start" data-id="element-643">
                  <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-644"></div>
                  <span data-id="element-645">Up to 20% off for early registration</span>
                </li>
                <li className="flex items-start" data-id="element-646">
                  <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-647"></div>
                  <span data-id="element-648">Group booking discounts available</span>
                </li>
                <li className="flex items-start" data-id="element-649">
                  <div className="w-2 h-2 bg-green-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-650"></div>
                  <span data-id="element-651">Alumni referral benefits</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-2xl shadow-lg" data-id="element-652">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-653">
                Secure Payment Methods
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-654">
                Multiple convenient payment options:
              </p>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-655">
                <li className="flex items-start" data-id="element-656">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-657"></div>
                  <span data-id="element-658">Razorpay, PayPal, Stripe</span>
                </li>
                <li className="flex items-start" data-id="element-659">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-660"></div>
                  <span data-id="element-661">UPI & digital wallets accepted</span>
                </li>
                <li className="flex items-start" data-id="element-662">
                  <div className="w-2 h-2 bg-purple-600 rounded-full mt-1.5 mr-2 flex-shrink-0" data-id="element-663"></div>
                  <span data-id="element-664">International currency support</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="text-center" data-id="element-665">
            <p className="text-gray-600 mb-6" data-id="element-666">
              Ready to start your integrative medicine education journey?
            </p>
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg" data-id="element-667">
              Enroll Now & Secure Your Spot
            </button>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-blue-50 w-full" data-id="element-668">
        <div className="max-w-7xl mx-auto" data-id="element-669">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-670">
            How to Enroll in Courses
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-671">
            {enrollmentSteps.map((step, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg" data-id="element-672">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-673">
                  {step.number}
                </div>
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-3" data-id="element-674">
                  <step.icon className="w-5 h-5 text-blue-600" data-id="element-675" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-676">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-677">{step.description}</p>
              </div>)}
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-xl mb-8" data-id="element-678">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-679">
              Special Benefits & Discounts
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-680">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-681">
                  <AwardIcon className="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-682" />
                  <p className="text-gray-700 text-sm" data-id="element-683">{benefit}</p>
                </div>)}
            </div>
          </div>
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-2xl text-center" data-id="element-684">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-685">
              Need More Information?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-686">
              For group bookings, early-bird discounts, or custom in-house
              training, contact us directly
            </p>
            <a href="mailto:amit.kapoor@aiimr.in" className="inline-flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-687">
              <MailIcon className="w-5 h-5 mr-2" data-id="element-688" />
              Email amit.kapoor@aiimr.in
            </a>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-689">
        <div className="max-w-4xl mx-auto" data-id="element-690">
          <div className="bg-gradient-to-br from-blue-600 to-teal-600 rounded-2xl p-8 text-white text-center" data-id="element-691">
            <UsersIcon className="w-16 h-16 mx-auto mb-6" data-id="element-692" />
            <h2 className="text-3xl font-bold mb-4" data-id="element-693">
              Ready to Advance Your Career?
            </h2>
            <p className="text-lg mb-8 opacity-90" data-id="element-694">
              Join our world-class training programs and become a certified
              integrative medicine practitioner
            </p>
            <div className="space-y-4" data-id="element-695">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-696">
                <p className="font-semibold mb-2" data-id="element-697">
                  Contact for Course Information:
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4 text-sm" data-id="element-698">
                  <a href="tel:+918303699990" className="flex items-center justify-center hover:underline" data-id="element-699">
                    <PhoneIcon className="w-4 h-4 mr-2" data-id="element-700" />
                    +91-8303699990
                  </a>
                  <a href="mailto:courses@aiimr.in" className="flex items-center justify-center hover:underline" data-id="element-701">
                    courses@aiimr.in
                  </a>
                </div>
              </div>
              <Link to="/contact" data-id="element-702">
                <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg" data-id="element-703">
                  Inquire About Courses
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}